import axios from "../Axios/axiosConfig";

export class SupportUsersService {
    baseUrl;

    constructor(serverUrl) {
        this.baseUrl = serverUrl;
    }

    async getAllUsers() {
        let users = [];
        const response = await axios.get(this.baseUrl + '/support-dashboard-assignees');
        response.data.forEach(user => {
            users.push({id: user.id, name: user.firstName});
        })
        return users;
    }
}
